function init() {

	$.ajax({
		type: "GET",
		url: "/api/GetCookieApi/GetCookieConsent"
	}).done(function (response) {
		deleteBrowserCookies(response)
	});

	function deleteBrowserCookies(cookieConsent) {
		let cookieName;
		for (let i = 0; i < cookieConsent.length; i++) {
			cookieName = cookieConsent[i].cookieName;
			if (!shvenergy.cookies.hasCookieCategoryConsent(cookieName) && shvenergy.cookies.getCookie(cookieName)) {
				shvenergy.cookies.setCookie(cookieName, "", -1);
			}
		}		
	}
}

init();
